<template>
  <h1 class="headline headline--type_h2">
    <slot />
  </h1>
</template>
